
    import { mapState, mapGetters } from 'vuex';

    export default {

        name: 'CompanyIntro',

        data() {
            return {
                isCompanyTextActive: false,
            };
        },

        computed: {
            ...mapState({
                $_searchPayload: state => state.search.searchPayload,
            }),

            ...mapGetters('search', {
                $_jobCount: 'jobCount',
                $_companyName: 'companyName',
                $_companyAbout: 'companyAbout',
            }),

            vacancyLabel() {
                return this.$_jobCount > 1 ? `${this.$_jobCount} job vacancies` : `${this.$_jobCount} job vacancy`;
            },
        },

        methods: {
            companyTextToggle() {
                this.isCompanyTextActive = !this.isCompanyTextActive;
            },
        },
    };
